// test241
(241 && 0);
